import { Navigate, Outlet, useParams } from 'react-router-dom'
import { useChallengeResolution } from '../../hooks/challenge/useChallengeId'
import { ScreenPath } from '../../navigation'
import styles from '../../ui/onboarding/GuardView.module.css'
import LoadingIndicator from '../../ui/util/LoadingIndicator'

export function hiddenChallengeDestination(hasVisibleWorkspace: boolean) {
  return hasVisibleWorkspace ? ScreenPath.home : ScreenPath.challenges
}

/** Funnel routes under `:challengeId`. A test challenge sends non-admins away. */
export default function ChallengeRoute() {
  const { challengeId } = useParams()
  const resolution = useChallengeResolution()

  if (resolution.isResolving) {
    return (
      <div className={styles.loading}>
        <LoadingIndicator />
      </div>
    )
  }

  if (challengeId && !resolution.canSee(challengeId)) {
    return <Navigate to={hiddenChallengeDestination(resolution.hasVisibleWorkspace)} replace />
  }

  return <Outlet />
}
